import * as React from 'react'
import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'
import type { ODataCustomFieldValue } from '@sales-center/common'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

const Cell = styled(Typography, { name: 'Cell', slot: 'Root', skipSx: true })`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

type GridCustomFieldValueProps = {
  value?: ODataCustomFieldValue
}

export function GridCustomFieldValue(props: GridCustomFieldValueProps) {
  const { value } = props
  const { formatDate } = useLocalizationDateFormat()

  if (!value) return null

  switch (value.type) {
    case 'Checkbox':
      return (
        <Cell>{value.bool ? 'Yes' : value.bool === false ? 'No' : ''}</Cell>
      )
    case 'Date':
      return <Cell>{formatDate(value.date)}</Cell>
    case 'DropdownMultiSelect':
      return <Cell>{value.customFieldValueOptionsList}</Cell>
    case 'DropdownSingleSelect':
      return <Cell>{value.customFieldOptionName}</Cell>
    case 'Number':
      return <Cell>{value.number}</Cell>
    case 'Text':
      return <Cell>{value.text}</Cell>
    default:
      return null
  }
}
